import * as angular from 'angular';
import { Constants as constants } from '../../constants';
import {portfolioManagerSummary} from './portfolioManagerSummary'
import {portfolioManagerExchangeRates} from './exchangerates/portfoliomanagement.exchangerate'
import {securityBalances} from './securityBalances/securityBalances.component'
import {clientBalances} from './clientBalances/clientBalances.component'

export const portfolioManagementModule = 'portfolioManagement';

angular
  .module(portfolioManagementModule, ['LocalStorageModule', 'ngMaterial', 'isoCurrency', 'dataGrid', 'pagination'])
  .constant("config", constants.Default)
  .component('portfolioManagerSummary',portfolioManagerSummary)
  .component('portfolioManagerExchangeRates', portfolioManagerExchangeRates)
  .component('securityBalances', securityBalances)
  .component('clientBalances', clientBalances)



// WEBPACK FOOTER //
// ./src/app/portfoliomanagement/portfoliomanagent.index.ts